import { listTasks } from './_store';

export default function smsSendTaskList(options) {
  let body = {};
  try {
    body = JSON.parse(options?.body || '{}');
  } catch (e) {
    body = {};
  }

  const data = listTasks({
    taskStatus: body.taskStatus,
    pageNo: body.pageNo,
    pageSize: body.pageSize,
  });

  return {
    code: 2001,
    data,
    message: 'success',
  };
}

